import { useMemo } from 'react';

import { BROWSER, DEVICE_TYPE, PAYMENT_METHOD } from '~common';

export const useUserAgent = () => {
  const userAgent = navigator.userAgent;

  const browser = useMemo(() => {
    if (userAgent.includes('Chrome') && !userAgent.includes('Edg'))
      return BROWSER.CHROME;
    if (userAgent.includes('Safari') && !userAgent.includes('Chrome'))
      return BROWSER.SAFARI;
    return BROWSER.OTHER;
  }, [userAgent]);

  const deviceType = useMemo(() => {
    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      return DEVICE_TYPE.IOS; // For iOS devices
    }
    if (/Android/i.test(userAgent)) {
      return DEVICE_TYPE.ANDROID; // For Android devices
    }
    return DEVICE_TYPE.COMPUTER; // Default to desktop for non-mobile
  }, [userAgent]);

  const availableWalletPaymentMethod: PAYMENT_METHOD =
    deviceType === DEVICE_TYPE.IOS || browser === BROWSER.SAFARI
      ? PAYMENT_METHOD.APPLE_PAY
      : PAYMENT_METHOD.GOOGLE_PAY;

  return { browser, deviceType, availableWalletPaymentMethod };
};
